// source: risk/risk.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var common_model_pb = require('../common/model_pb.js');
goog.object.extend(proto, common_model_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
goog.exportSymbol('proto.risk.CreateOrUpdateRiskStatusRequest', null, global);
goog.exportSymbol('proto.risk.CreateOrUpdateRisksInternalRequest', null, global);
goog.exportSymbol('proto.risk.CreateOrUpdateRisksInternalResponse', null, global);
goog.exportSymbol('proto.risk.CreateOrUpdateRisksRequest', null, global);
goog.exportSymbol('proto.risk.CreateRiskEvaluationCriteriaRequest', null, global);
goog.exportSymbol('proto.risk.DeleteRiskCategoryOptionRequest', null, global);
goog.exportSymbol('proto.risk.DeleteRiskEvaluationCriteriaRequest', null, global);
goog.exportSymbol('proto.risk.DeleteRiskStatusRequest', null, global);
goog.exportSymbol('proto.risk.DeleteRisksRequest', null, global);
goog.exportSymbol('proto.risk.DownloadRiskCSVRequest', null, global);
goog.exportSymbol('proto.risk.DownloadRiskCSVResponse', null, global);
goog.exportSymbol('proto.risk.EvaluateRiskRequest', null, global);
goog.exportSymbol('proto.risk.GetRiskCategoryOptionResponse', null, global);
goog.exportSymbol('proto.risk.GetRisksByIdsRequest', null, global);
goog.exportSymbol('proto.risk.GetRisksRequest', null, global);
goog.exportSymbol('proto.risk.GetRisksResponse', null, global);
goog.exportSymbol('proto.risk.ImportRisksRequest', null, global);
goog.exportSymbol('proto.risk.ImportRisksResponse', null, global);
goog.exportSymbol('proto.risk.IsRiskSetFilter', null, global);
goog.exportSymbol('proto.risk.ListRiskEvaluationCriteriaRequest', null, global);
goog.exportSymbol('proto.risk.ListRiskEvaluationCriteriaResponse', null, global);
goog.exportSymbol('proto.risk.ListRiskEvaluationCriteriaVersionsRequest', null, global);
goog.exportSymbol('proto.risk.ListRiskEvaluationCriteriaVersionsResponse', null, global);
goog.exportSymbol('proto.risk.ListRiskEvaluationsRequest', null, global);
goog.exportSymbol('proto.risk.ListRiskEvaluationsResponse', null, global);
goog.exportSymbol('proto.risk.RISK_CATEGORY', null, global);
goog.exportSymbol('proto.risk.RISK_IMPORT_FIELD', null, global);
goog.exportSymbol('proto.risk.RISK_LINK_TYPE', null, global);
goog.exportSymbol('proto.risk.RISK_MATH', null, global);
goog.exportSymbol('proto.risk.RISK_STATUS', null, global);
goog.exportSymbol('proto.risk.RISK_TREATMENT', null, global);
goog.exportSymbol('proto.risk.RISK_TYPE', null, global);
goog.exportSymbol('proto.risk.Risk', null, global);
goog.exportSymbol('proto.risk.RiskCategoryOption', null, global);
goog.exportSymbol('proto.risk.RiskEvaluationCriteria', null, global);
goog.exportSymbol('proto.risk.RiskEvaluationCriteriaDraft', null, global);
goog.exportSymbol('proto.risk.RiskEvaluationCriteriaVersion', null, global);
goog.exportSymbol('proto.risk.RiskEvaluationCriteriaVersionItem', null, global);
goog.exportSymbol('proto.risk.RiskEvaluationCriterionResult', null, global);
goog.exportSymbol('proto.risk.RiskEvaluationResult', null, global);
goog.exportSymbol('proto.risk.RiskFilter', null, global);
goog.exportSymbol('proto.risk.RiskLink', null, global);
goog.exportSymbol('proto.risk.RiskSort', null, global);
goog.exportSymbol('proto.risk.RiskSort.RiskSortTuple', null, global);
goog.exportSymbol('proto.risk.RiskStatusItem', null, global);
goog.exportSymbol('proto.risk.RiskStatuses', null, global);
goog.exportSymbol('proto.risk.SetRiskAssigneesRequest', null, global);
goog.exportSymbol('proto.risk.SetRiskEvaluationCriteriaInternalRequest', null, global);
goog.exportSymbol('proto.risk.ToggleRiskLinksInternalRequest', null, global);
goog.exportSymbol('proto.risk.ToggleRiskLinksRequest', null, global);
goog.exportSymbol('proto.risk.UpdateRiskEvaluationCriteriaRequest', null, global);
goog.exportSymbol('proto.risk.UpsertRiskCategoryOptionRequest', null, global);
goog.exportSymbol('proto.risk.WrittenRisk', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.Risk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.Risk.repeatedFields_, null);
};
goog.inherits(proto.risk.Risk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.Risk.displayName = 'proto.risk.Risk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.IsRiskSetFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.IsRiskSetFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.IsRiskSetFilter.displayName = 'proto.risk.IsRiskSetFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.RiskFilter.repeatedFields_, null);
};
goog.inherits(proto.risk.RiskFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskFilter.displayName = 'proto.risk.RiskFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.SetRiskAssigneesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.SetRiskAssigneesRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.SetRiskAssigneesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.SetRiskAssigneesRequest.displayName = 'proto.risk.SetRiskAssigneesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskSort = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.RiskSort.repeatedFields_, null);
};
goog.inherits(proto.risk.RiskSort, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskSort.displayName = 'proto.risk.RiskSort';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskSort.RiskSortTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.RiskSort.RiskSortTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskSort.RiskSortTuple.displayName = 'proto.risk.RiskSort.RiskSortTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.GetRisksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.GetRisksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.GetRisksRequest.displayName = 'proto.risk.GetRisksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.GetRisksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.GetRisksResponse.repeatedFields_, null);
};
goog.inherits(proto.risk.GetRisksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.GetRisksResponse.displayName = 'proto.risk.GetRisksResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.GetRisksByIdsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.GetRisksByIdsRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.GetRisksByIdsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.GetRisksByIdsRequest.displayName = 'proto.risk.GetRisksByIdsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.CreateOrUpdateRisksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.CreateOrUpdateRisksRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.CreateOrUpdateRisksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.CreateOrUpdateRisksRequest.displayName = 'proto.risk.CreateOrUpdateRisksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.ImportRisksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.ImportRisksRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.ImportRisksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.ImportRisksRequest.displayName = 'proto.risk.ImportRisksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.ImportRisksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.ImportRisksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.ImportRisksResponse.displayName = 'proto.risk.ImportRisksResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.DeleteRisksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.DeleteRisksRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.DeleteRisksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.DeleteRisksRequest.displayName = 'proto.risk.DeleteRisksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskLink = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.RiskLink, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskLink.displayName = 'proto.risk.RiskLink';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.ToggleRiskLinksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.ToggleRiskLinksRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.ToggleRiskLinksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.ToggleRiskLinksRequest.displayName = 'proto.risk.ToggleRiskLinksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.CreateOrUpdateRisksInternalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.CreateOrUpdateRisksInternalRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.CreateOrUpdateRisksInternalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.CreateOrUpdateRisksInternalRequest.displayName = 'proto.risk.CreateOrUpdateRisksInternalRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.WrittenRisk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.WrittenRisk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.WrittenRisk.displayName = 'proto.risk.WrittenRisk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.CreateOrUpdateRisksInternalResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.CreateOrUpdateRisksInternalResponse.repeatedFields_, null);
};
goog.inherits(proto.risk.CreateOrUpdateRisksInternalResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.CreateOrUpdateRisksInternalResponse.displayName = 'proto.risk.CreateOrUpdateRisksInternalResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskEvaluationCriteriaDraft = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.RiskEvaluationCriteriaDraft, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskEvaluationCriteriaDraft.displayName = 'proto.risk.RiskEvaluationCriteriaDraft';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.SetRiskEvaluationCriteriaInternalRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.SetRiskEvaluationCriteriaInternalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.SetRiskEvaluationCriteriaInternalRequest.displayName = 'proto.risk.SetRiskEvaluationCriteriaInternalRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.ToggleRiskLinksInternalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.ToggleRiskLinksInternalRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.ToggleRiskLinksInternalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.ToggleRiskLinksInternalRequest.displayName = 'proto.risk.ToggleRiskLinksInternalRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.DownloadRiskCSVRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.DownloadRiskCSVRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.DownloadRiskCSVRequest.displayName = 'proto.risk.DownloadRiskCSVRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.DownloadRiskCSVResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.DownloadRiskCSVResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.DownloadRiskCSVResponse.displayName = 'proto.risk.DownloadRiskCSVResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.GetRiskCategoryOptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.GetRiskCategoryOptionResponse.repeatedFields_, null);
};
goog.inherits(proto.risk.GetRiskCategoryOptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.GetRiskCategoryOptionResponse.displayName = 'proto.risk.GetRiskCategoryOptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskCategoryOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.RiskCategoryOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskCategoryOption.displayName = 'proto.risk.RiskCategoryOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.DeleteRiskCategoryOptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.DeleteRiskCategoryOptionRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.DeleteRiskCategoryOptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.DeleteRiskCategoryOptionRequest.displayName = 'proto.risk.DeleteRiskCategoryOptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.UpsertRiskCategoryOptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.UpsertRiskCategoryOptionRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.UpsertRiskCategoryOptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.UpsertRiskCategoryOptionRequest.displayName = 'proto.risk.UpsertRiskCategoryOptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskEvaluationCriteria = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.RiskEvaluationCriteria, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskEvaluationCriteria.displayName = 'proto.risk.RiskEvaluationCriteria';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.EvaluateRiskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.EvaluateRiskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.EvaluateRiskRequest.displayName = 'proto.risk.EvaluateRiskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.ListRiskEvaluationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.ListRiskEvaluationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.ListRiskEvaluationsRequest.displayName = 'proto.risk.ListRiskEvaluationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.ListRiskEvaluationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.ListRiskEvaluationsResponse.repeatedFields_, null);
};
goog.inherits(proto.risk.ListRiskEvaluationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.ListRiskEvaluationsResponse.displayName = 'proto.risk.ListRiskEvaluationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskEvaluationResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.RiskEvaluationResult.repeatedFields_, null);
};
goog.inherits(proto.risk.RiskEvaluationResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskEvaluationResult.displayName = 'proto.risk.RiskEvaluationResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskEvaluationCriterionResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.RiskEvaluationCriterionResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskEvaluationCriterionResult.displayName = 'proto.risk.RiskEvaluationCriterionResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.ListRiskEvaluationCriteriaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.ListRiskEvaluationCriteriaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.ListRiskEvaluationCriteriaRequest.displayName = 'proto.risk.ListRiskEvaluationCriteriaRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.ListRiskEvaluationCriteriaResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.ListRiskEvaluationCriteriaResponse.repeatedFields_, null);
};
goog.inherits(proto.risk.ListRiskEvaluationCriteriaResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.ListRiskEvaluationCriteriaResponse.displayName = 'proto.risk.ListRiskEvaluationCriteriaResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.CreateRiskEvaluationCriteriaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.CreateRiskEvaluationCriteriaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.CreateRiskEvaluationCriteriaRequest.displayName = 'proto.risk.CreateRiskEvaluationCriteriaRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.UpdateRiskEvaluationCriteriaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.UpdateRiskEvaluationCriteriaRequest.displayName = 'proto.risk.UpdateRiskEvaluationCriteriaRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.DeleteRiskEvaluationCriteriaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.DeleteRiskEvaluationCriteriaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.DeleteRiskEvaluationCriteriaRequest.displayName = 'proto.risk.DeleteRiskEvaluationCriteriaRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskEvaluationCriteriaVersionItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.RiskEvaluationCriteriaVersionItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskEvaluationCriteriaVersionItem.displayName = 'proto.risk.RiskEvaluationCriteriaVersionItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskEvaluationCriteriaVersion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.RiskEvaluationCriteriaVersion.repeatedFields_, null);
};
goog.inherits(proto.risk.RiskEvaluationCriteriaVersion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskEvaluationCriteriaVersion.displayName = 'proto.risk.RiskEvaluationCriteriaVersion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.ListRiskEvaluationCriteriaVersionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.ListRiskEvaluationCriteriaVersionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.ListRiskEvaluationCriteriaVersionsRequest.displayName = 'proto.risk.ListRiskEvaluationCriteriaVersionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.ListRiskEvaluationCriteriaVersionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.ListRiskEvaluationCriteriaVersionsResponse.repeatedFields_, null);
};
goog.inherits(proto.risk.ListRiskEvaluationCriteriaVersionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.ListRiskEvaluationCriteriaVersionsResponse.displayName = 'proto.risk.ListRiskEvaluationCriteriaVersionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskStatusItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.RiskStatusItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskStatusItem.displayName = 'proto.risk.RiskStatusItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.RiskStatuses = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.RiskStatuses.repeatedFields_, null);
};
goog.inherits(proto.risk.RiskStatuses, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.RiskStatuses.displayName = 'proto.risk.RiskStatuses';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.CreateOrUpdateRiskStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.risk.CreateOrUpdateRiskStatusRequest.repeatedFields_, null);
};
goog.inherits(proto.risk.CreateOrUpdateRiskStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.CreateOrUpdateRiskStatusRequest.displayName = 'proto.risk.CreateOrUpdateRiskStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.risk.DeleteRiskStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.risk.DeleteRiskStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.risk.DeleteRiskStatusRequest.displayName = 'proto.risk.DeleteRiskStatusRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.Risk.repeatedFields_ = [26,27];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.Risk.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.Risk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.Risk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.Risk.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 2, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
    accountId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    description: jspb.Message.getFieldWithDefault(msg, 6, ""),
    departmentId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    customId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    status: jspb.Message.getFieldWithDefault(msg, 9, 0),
    ownerEmail: jspb.Message.getFieldWithDefault(msg, 10, ""),
    predisposingCondition: jspb.Message.getFieldWithDefault(msg, 11, ""),
    assetAtRisk: jspb.Message.getFieldWithDefault(msg, 12, ""),
    impactToCustomer: jspb.Message.getFieldWithDefault(msg, 13, ""),
    likelihood: jspb.Message.getFieldWithDefault(msg, 14, 0),
    adverseImpact: jspb.Message.getFieldWithDefault(msg, 15, 0),
    treatment: jspb.Message.getFieldWithDefault(msg, 16, 0),
    riskAfterTreatment: jspb.Message.getFieldWithDefault(msg, 17, 0),
    category: jspb.Message.getFieldWithDefault(msg, 18, 0),
    notes: jspb.Message.getFieldWithDefault(msg, 19, ""),
    controlIds: jspb.Message.getFieldWithDefault(msg, 20, ""),
    closedAt: jspb.Message.getFieldWithDefault(msg, 21, 0),
    successfulControls: jspb.Message.getFieldWithDefault(msg, 22, ""),
    targetLikelihood: jspb.Message.getFieldWithDefault(msg, 23, 0),
    targetAdverseImpact: jspb.Message.getFieldWithDefault(msg, 24, 0),
    lastReviewedAt: jspb.Message.getFieldWithDefault(msg, 25, 0),
    departmentIdsList: (f = jspb.Message.getRepeatedField(msg, 26)) == null ? undefined : f,
    assigneeEmailsList: (f = jspb.Message.getRepeatedField(msg, 27)) == null ? undefined : f,
    customStatusId: jspb.Message.getFieldWithDefault(msg, 28, ""),
    statusChangedAt: jspb.Message.getFieldWithDefault(msg, 29, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.Risk}
 */
proto.risk.Risk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.Risk;
  return proto.risk.Risk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.Risk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.Risk}
 */
proto.risk.Risk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartmentId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomId(value);
      break;
    case 9:
      var value = /** @type {!proto.risk.RISK_STATUS} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerEmail(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPredisposingCondition(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssetAtRisk(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setImpactToCustomer(value);
      break;
    case 14:
      var value = /** @type {!proto.risk.RISK_MATH} */ (reader.readEnum());
      msg.setLikelihood(value);
      break;
    case 15:
      var value = /** @type {!proto.risk.RISK_MATH} */ (reader.readEnum());
      msg.setAdverseImpact(value);
      break;
    case 16:
      var value = /** @type {!proto.risk.RISK_TREATMENT} */ (reader.readEnum());
      msg.setTreatment(value);
      break;
    case 17:
      var value = /** @type {!proto.risk.RISK_MATH} */ (reader.readEnum());
      msg.setRiskAfterTreatment(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCategory(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlIds(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setClosedAt(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuccessfulControls(value);
      break;
    case 23:
      var value = /** @type {!proto.risk.RISK_MATH} */ (reader.readEnum());
      msg.setTargetLikelihood(value);
      break;
    case 24:
      var value = /** @type {!proto.risk.RISK_MATH} */ (reader.readEnum());
      msg.setTargetAdverseImpact(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastReviewedAt(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.addDepartmentIds(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.addAssigneeEmails(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomStatusId(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStatusChangedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.Risk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.Risk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.Risk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.Risk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDepartmentId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCustomId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getOwnerEmail();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPredisposingCondition();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAssetAtRisk();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getImpactToCustomer();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getLikelihood();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getAdverseImpact();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getTreatment();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getRiskAfterTreatment();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getControlIds();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getClosedAt();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getSuccessfulControls();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getTargetLikelihood();
  if (f !== 0.0) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = message.getTargetAdverseImpact();
  if (f !== 0.0) {
    writer.writeEnum(
      24,
      f
    );
  }
  f = message.getLastReviewedAt();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getDepartmentIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      26,
      f
    );
  }
  f = message.getAssigneeEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      27,
      f
    );
  }
  f = message.getCustomStatusId();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getStatusChangedAt();
  if (f !== 0) {
    writer.writeInt64(
      29,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.risk.Risk.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 created_at = 2;
 * @return {number}
 */
proto.risk.Risk.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 updated_at = 3;
 * @return {number}
 */
proto.risk.Risk.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string account_id = 4;
 * @return {string}
 */
proto.risk.Risk.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.risk.Risk.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.risk.Risk.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string department_id = 7;
 * @return {string}
 */
proto.risk.Risk.prototype.getDepartmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setDepartmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string custom_id = 8;
 * @return {string}
 */
proto.risk.Risk.prototype.getCustomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setCustomId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional RISK_STATUS status = 9;
 * @return {!proto.risk.RISK_STATUS}
 */
proto.risk.Risk.prototype.getStatus = function() {
  return /** @type {!proto.risk.RISK_STATUS} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.risk.RISK_STATUS} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string owner_email = 10;
 * @return {string}
 */
proto.risk.Risk.prototype.getOwnerEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setOwnerEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string predisposing_condition = 11;
 * @return {string}
 */
proto.risk.Risk.prototype.getPredisposingCondition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setPredisposingCondition = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string asset_at_risk = 12;
 * @return {string}
 */
proto.risk.Risk.prototype.getAssetAtRisk = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setAssetAtRisk = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string impact_to_customer = 13;
 * @return {string}
 */
proto.risk.Risk.prototype.getImpactToCustomer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setImpactToCustomer = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional RISK_MATH likelihood = 14;
 * @return {!proto.risk.RISK_MATH}
 */
proto.risk.Risk.prototype.getLikelihood = function() {
  return /** @type {!proto.risk.RISK_MATH} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.risk.RISK_MATH} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setLikelihood = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional RISK_MATH adverse_impact = 15;
 * @return {!proto.risk.RISK_MATH}
 */
proto.risk.Risk.prototype.getAdverseImpact = function() {
  return /** @type {!proto.risk.RISK_MATH} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.risk.RISK_MATH} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setAdverseImpact = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional RISK_TREATMENT treatment = 16;
 * @return {!proto.risk.RISK_TREATMENT}
 */
proto.risk.Risk.prototype.getTreatment = function() {
  return /** @type {!proto.risk.RISK_TREATMENT} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.risk.RISK_TREATMENT} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setTreatment = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional RISK_MATH risk_after_treatment = 17;
 * @return {!proto.risk.RISK_MATH}
 */
proto.risk.Risk.prototype.getRiskAfterTreatment = function() {
  return /** @type {!proto.risk.RISK_MATH} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.risk.RISK_MATH} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setRiskAfterTreatment = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional int32 category = 18;
 * @return {number}
 */
proto.risk.Risk.prototype.getCategory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setCategory = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string notes = 19;
 * @return {string}
 */
proto.risk.Risk.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string control_ids = 20;
 * @return {string}
 */
proto.risk.Risk.prototype.getControlIds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setControlIds = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional int64 closed_at = 21;
 * @return {number}
 */
proto.risk.Risk.prototype.getClosedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setClosedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string successful_controls = 22;
 * @return {string}
 */
proto.risk.Risk.prototype.getSuccessfulControls = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setSuccessfulControls = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional RISK_MATH target_likelihood = 23;
 * @return {!proto.risk.RISK_MATH}
 */
proto.risk.Risk.prototype.getTargetLikelihood = function() {
  return /** @type {!proto.risk.RISK_MATH} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.risk.RISK_MATH} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setTargetLikelihood = function(value) {
  return jspb.Message.setProto3EnumField(this, 23, value);
};


/**
 * optional RISK_MATH target_adverse_impact = 24;
 * @return {!proto.risk.RISK_MATH}
 */
proto.risk.Risk.prototype.getTargetAdverseImpact = function() {
  return /** @type {!proto.risk.RISK_MATH} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {!proto.risk.RISK_MATH} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setTargetAdverseImpact = function(value) {
  return jspb.Message.setProto3EnumField(this, 24, value);
};


/**
 * optional int64 last_reviewed_at = 25;
 * @return {number}
 */
proto.risk.Risk.prototype.getLastReviewedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setLastReviewedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * repeated string department_ids = 26;
 * @return {!Array<string>}
 */
proto.risk.Risk.prototype.getDepartmentIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 26));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setDepartmentIdsList = function(value) {
  return jspb.Message.setField(this, 26, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.addDepartmentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 26, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.clearDepartmentIdsList = function() {
  return this.setDepartmentIdsList([]);
};


/**
 * repeated string assignee_emails = 27;
 * @return {!Array<string>}
 */
proto.risk.Risk.prototype.getAssigneeEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 27));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setAssigneeEmailsList = function(value) {
  return jspb.Message.setField(this, 27, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.addAssigneeEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 27, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.clearAssigneeEmailsList = function() {
  return this.setAssigneeEmailsList([]);
};


/**
 * optional string custom_status_id = 28;
 * @return {string}
 */
proto.risk.Risk.prototype.getCustomStatusId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setCustomStatusId = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional int64 status_changed_at = 29;
 * @return {number}
 */
proto.risk.Risk.prototype.getStatusChangedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.Risk} returns this
 */
proto.risk.Risk.prototype.setStatusChangedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.IsRiskSetFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.IsRiskSetFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.IsRiskSetFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.IsRiskSetFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    isSet: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.IsRiskSetFilter}
 */
proto.risk.IsRiskSetFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.IsRiskSetFilter;
  return proto.risk.IsRiskSetFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.IsRiskSetFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.IsRiskSetFilter}
 */
proto.risk.IsRiskSetFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.risk.RISK_TYPE} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSet(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.IsRiskSetFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.IsRiskSetFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.IsRiskSetFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.IsRiskSetFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getIsSet();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional RISK_TYPE type = 1;
 * @return {!proto.risk.RISK_TYPE}
 */
proto.risk.IsRiskSetFilter.prototype.getType = function() {
  return /** @type {!proto.risk.RISK_TYPE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.risk.RISK_TYPE} value
 * @return {!proto.risk.IsRiskSetFilter} returns this
 */
proto.risk.IsRiskSetFilter.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool is_set = 2;
 * @return {boolean}
 */
proto.risk.IsRiskSetFilter.prototype.getIsSet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.risk.IsRiskSetFilter} returns this
 */
proto.risk.IsRiskSetFilter.prototype.setIsSet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.RiskFilter.repeatedFields_ = [1,2,3,5,7,8,9,10,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    controlIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    departmentIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    includeNoDepartment: (f = msg.getIncludeNoDepartment()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    ownerEmailsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    includeUnassigned: (f = msg.getIncludeUnassigned()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    statusesList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    riskMathFiltersList: jspb.Message.toObjectList(msg.getRiskMathFiltersList(),
    proto.risk.IsRiskSetFilter.toObject, includeInstance),
    vendorIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    assigneeEmailsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    categoriesList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    assigneeIncludeUnassigned: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    reviewed: (f = msg.getReviewed()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskFilter}
 */
proto.risk.RiskFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskFilter;
  return proto.risk.RiskFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskFilter}
 */
proto.risk.RiskFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addRiskIds(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addControlIds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addDepartmentIds(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIncludeNoDepartment(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addOwnerEmails(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIncludeUnassigned(value);
      break;
    case 7:
      var values = /** @type {!Array<!proto.risk.RISK_STATUS>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addStatuses(values[i]);
      }
      break;
    case 8:
      var value = new proto.risk.IsRiskSetFilter;
      reader.readMessage(value,proto.risk.IsRiskSetFilter.deserializeBinaryFromReader);
      msg.addRiskMathFilters(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addVendorIds(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addAssigneeEmails(value);
      break;
    case 11:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCategories(values[i]);
      }
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAssigneeIncludeUnassigned(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setReviewed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getControlIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getDepartmentIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getIncludeNoDepartment();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getOwnerEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getIncludeUnassigned();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getStatusesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getRiskMathFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.risk.IsRiskSetFilter.serializeBinaryToWriter
    );
  }
  f = message.getVendorIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getAssigneeEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      11,
      f
    );
  }
  f = message.getAssigneeIncludeUnassigned();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getReviewed();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string risk_ids = 1;
 * @return {!Array<string>}
 */
proto.risk.RiskFilter.prototype.getRiskIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.setRiskIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.addRiskIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearRiskIdsList = function() {
  return this.setRiskIdsList([]);
};


/**
 * repeated string control_ids = 2;
 * @return {!Array<string>}
 */
proto.risk.RiskFilter.prototype.getControlIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.setControlIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.addControlIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearControlIdsList = function() {
  return this.setControlIdsList([]);
};


/**
 * repeated string department_ids = 3;
 * @return {!Array<string>}
 */
proto.risk.RiskFilter.prototype.getDepartmentIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.setDepartmentIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.addDepartmentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearDepartmentIdsList = function() {
  return this.setDepartmentIdsList([]);
};


/**
 * optional google.protobuf.BoolValue include_no_department = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.risk.RiskFilter.prototype.getIncludeNoDepartment = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.risk.RiskFilter} returns this
*/
proto.risk.RiskFilter.prototype.setIncludeNoDepartment = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearIncludeNoDepartment = function() {
  return this.setIncludeNoDepartment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.risk.RiskFilter.prototype.hasIncludeNoDepartment = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated string owner_emails = 5;
 * @return {!Array<string>}
 */
proto.risk.RiskFilter.prototype.getOwnerEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.setOwnerEmailsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.addOwnerEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearOwnerEmailsList = function() {
  return this.setOwnerEmailsList([]);
};


/**
 * optional google.protobuf.BoolValue include_unassigned = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.risk.RiskFilter.prototype.getIncludeUnassigned = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.risk.RiskFilter} returns this
*/
proto.risk.RiskFilter.prototype.setIncludeUnassigned = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearIncludeUnassigned = function() {
  return this.setIncludeUnassigned(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.risk.RiskFilter.prototype.hasIncludeUnassigned = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated RISK_STATUS statuses = 7;
 * @return {!Array<!proto.risk.RISK_STATUS>}
 */
proto.risk.RiskFilter.prototype.getStatusesList = function() {
  return /** @type {!Array<!proto.risk.RISK_STATUS>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<!proto.risk.RISK_STATUS>} value
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.setStatusesList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.risk.RISK_STATUS} value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.addStatuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearStatusesList = function() {
  return this.setStatusesList([]);
};


/**
 * repeated IsRiskSetFilter risk_math_filters = 8;
 * @return {!Array<!proto.risk.IsRiskSetFilter>}
 */
proto.risk.RiskFilter.prototype.getRiskMathFiltersList = function() {
  return /** @type{!Array<!proto.risk.IsRiskSetFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.IsRiskSetFilter, 8));
};


/**
 * @param {!Array<!proto.risk.IsRiskSetFilter>} value
 * @return {!proto.risk.RiskFilter} returns this
*/
proto.risk.RiskFilter.prototype.setRiskMathFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.risk.IsRiskSetFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.IsRiskSetFilter}
 */
proto.risk.RiskFilter.prototype.addRiskMathFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.risk.IsRiskSetFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearRiskMathFiltersList = function() {
  return this.setRiskMathFiltersList([]);
};


/**
 * repeated string vendor_ids = 9;
 * @return {!Array<string>}
 */
proto.risk.RiskFilter.prototype.getVendorIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.setVendorIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.addVendorIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearVendorIdsList = function() {
  return this.setVendorIdsList([]);
};


/**
 * repeated string assignee_emails = 10;
 * @return {!Array<string>}
 */
proto.risk.RiskFilter.prototype.getAssigneeEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.setAssigneeEmailsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.addAssigneeEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearAssigneeEmailsList = function() {
  return this.setAssigneeEmailsList([]);
};


/**
 * repeated int32 categories = 11;
 * @return {!Array<number>}
 */
proto.risk.RiskFilter.prototype.getCategoriesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * optional bool assignee_include_unassigned = 12;
 * @return {boolean}
 */
proto.risk.RiskFilter.prototype.getAssigneeIncludeUnassigned = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.setAssigneeIncludeUnassigned = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional google.protobuf.BoolValue reviewed = 13;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.risk.RiskFilter.prototype.getReviewed = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 13));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.risk.RiskFilter} returns this
*/
proto.risk.RiskFilter.prototype.setReviewed = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.risk.RiskFilter} returns this
 */
proto.risk.RiskFilter.prototype.clearReviewed = function() {
  return this.setReviewed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.risk.RiskFilter.prototype.hasReviewed = function() {
  return jspb.Message.getField(this, 13) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.SetRiskAssigneesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.SetRiskAssigneesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.SetRiskAssigneesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.SetRiskAssigneesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.SetRiskAssigneesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    assigneeEmailsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.SetRiskAssigneesRequest}
 */
proto.risk.SetRiskAssigneesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.SetRiskAssigneesRequest;
  return proto.risk.SetRiskAssigneesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.SetRiskAssigneesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.SetRiskAssigneesRequest}
 */
proto.risk.SetRiskAssigneesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAssigneeEmails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.SetRiskAssigneesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.SetRiskAssigneesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.SetRiskAssigneesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.SetRiskAssigneesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAssigneeEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string risk_id = 1;
 * @return {string}
 */
proto.risk.SetRiskAssigneesRequest.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.SetRiskAssigneesRequest} returns this
 */
proto.risk.SetRiskAssigneesRequest.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string assignee_emails = 2;
 * @return {!Array<string>}
 */
proto.risk.SetRiskAssigneesRequest.prototype.getAssigneeEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.risk.SetRiskAssigneesRequest} returns this
 */
proto.risk.SetRiskAssigneesRequest.prototype.setAssigneeEmailsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.risk.SetRiskAssigneesRequest} returns this
 */
proto.risk.SetRiskAssigneesRequest.prototype.addAssigneeEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.SetRiskAssigneesRequest} returns this
 */
proto.risk.SetRiskAssigneesRequest.prototype.clearAssigneeEmailsList = function() {
  return this.setAssigneeEmailsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.RiskSort.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskSort.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskSort.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskSort} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskSort.toObject = function(includeInstance, msg) {
  var f, obj = {
    sortListList: jspb.Message.toObjectList(msg.getSortListList(),
    proto.risk.RiskSort.RiskSortTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskSort}
 */
proto.risk.RiskSort.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskSort;
  return proto.risk.RiskSort.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskSort} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskSort}
 */
proto.risk.RiskSort.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.RiskSort.RiskSortTuple;
      reader.readMessage(value,proto.risk.RiskSort.RiskSortTuple.deserializeBinaryFromReader);
      msg.addSortList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskSort.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskSort.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskSort} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskSort.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSortListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.RiskSort.RiskSortTuple.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskSort.RiskSortTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskSort.RiskSortTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskSort.RiskSortTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskSort.RiskSortTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    field: jspb.Message.getFieldWithDefault(msg, 1, ""),
    direction: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskSort.RiskSortTuple}
 */
proto.risk.RiskSort.RiskSortTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskSort.RiskSortTuple;
  return proto.risk.RiskSort.RiskSortTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskSort.RiskSortTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskSort.RiskSortTuple}
 */
proto.risk.RiskSort.RiskSortTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setField(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDirection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskSort.RiskSortTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskSort.RiskSortTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskSort.RiskSortTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskSort.RiskSortTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getField();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDirection();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string field = 1;
 * @return {string}
 */
proto.risk.RiskSort.RiskSortTuple.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskSort.RiskSortTuple} returns this
 */
proto.risk.RiskSort.RiskSortTuple.prototype.setField = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string direction = 2;
 * @return {string}
 */
proto.risk.RiskSort.RiskSortTuple.prototype.getDirection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskSort.RiskSortTuple} returns this
 */
proto.risk.RiskSort.RiskSortTuple.prototype.setDirection = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated RiskSortTuple sort_list = 1;
 * @return {!Array<!proto.risk.RiskSort.RiskSortTuple>}
 */
proto.risk.RiskSort.prototype.getSortListList = function() {
  return /** @type{!Array<!proto.risk.RiskSort.RiskSortTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskSort.RiskSortTuple, 1));
};


/**
 * @param {!Array<!proto.risk.RiskSort.RiskSortTuple>} value
 * @return {!proto.risk.RiskSort} returns this
*/
proto.risk.RiskSort.prototype.setSortListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.RiskSort.RiskSortTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskSort.RiskSortTuple}
 */
proto.risk.RiskSort.prototype.addSortList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.RiskSort.RiskSortTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskSort} returns this
 */
proto.risk.RiskSort.prototype.clearSortListList = function() {
  return this.setSortListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.GetRisksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.GetRisksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.GetRisksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.GetRisksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    filterBy: (f = msg.getFilterBy()) && proto.risk.RiskFilter.toObject(includeInstance, f),
    sortBy: (f = msg.getSortBy()) && proto.risk.RiskSort.toObject(includeInstance, f),
    auditId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.GetRisksRequest}
 */
proto.risk.GetRisksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.GetRisksRequest;
  return proto.risk.GetRisksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.GetRisksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.GetRisksRequest}
 */
proto.risk.GetRisksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.RiskFilter;
      reader.readMessage(value,proto.risk.RiskFilter.deserializeBinaryFromReader);
      msg.setFilterBy(value);
      break;
    case 2:
      var value = new proto.risk.RiskSort;
      reader.readMessage(value,proto.risk.RiskSort.deserializeBinaryFromReader);
      msg.setSortBy(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.GetRisksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.GetRisksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.GetRisksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.GetRisksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilterBy();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.risk.RiskFilter.serializeBinaryToWriter
    );
  }
  f = message.getSortBy();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.risk.RiskSort.serializeBinaryToWriter
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional RiskFilter filter_by = 1;
 * @return {?proto.risk.RiskFilter}
 */
proto.risk.GetRisksRequest.prototype.getFilterBy = function() {
  return /** @type{?proto.risk.RiskFilter} */ (
    jspb.Message.getWrapperField(this, proto.risk.RiskFilter, 1));
};


/**
 * @param {?proto.risk.RiskFilter|undefined} value
 * @return {!proto.risk.GetRisksRequest} returns this
*/
proto.risk.GetRisksRequest.prototype.setFilterBy = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.risk.GetRisksRequest} returns this
 */
proto.risk.GetRisksRequest.prototype.clearFilterBy = function() {
  return this.setFilterBy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.risk.GetRisksRequest.prototype.hasFilterBy = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RiskSort sort_by = 2;
 * @return {?proto.risk.RiskSort}
 */
proto.risk.GetRisksRequest.prototype.getSortBy = function() {
  return /** @type{?proto.risk.RiskSort} */ (
    jspb.Message.getWrapperField(this, proto.risk.RiskSort, 2));
};


/**
 * @param {?proto.risk.RiskSort|undefined} value
 * @return {!proto.risk.GetRisksRequest} returns this
*/
proto.risk.GetRisksRequest.prototype.setSortBy = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.risk.GetRisksRequest} returns this
 */
proto.risk.GetRisksRequest.prototype.clearSortBy = function() {
  return this.setSortBy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.risk.GetRisksRequest.prototype.hasSortBy = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string audit_id = 3;
 * @return {string}
 */
proto.risk.GetRisksRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.GetRisksRequest} returns this
 */
proto.risk.GetRisksRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.GetRisksResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.GetRisksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.GetRisksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.GetRisksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.GetRisksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    risksList: jspb.Message.toObjectList(msg.getRisksList(),
    proto.risk.Risk.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.GetRisksResponse}
 */
proto.risk.GetRisksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.GetRisksResponse;
  return proto.risk.GetRisksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.GetRisksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.GetRisksResponse}
 */
proto.risk.GetRisksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.Risk;
      reader.readMessage(value,proto.risk.Risk.deserializeBinaryFromReader);
      msg.addRisks(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.GetRisksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.GetRisksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.GetRisksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.GetRisksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRisksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.Risk.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated Risk risks = 1;
 * @return {!Array<!proto.risk.Risk>}
 */
proto.risk.GetRisksResponse.prototype.getRisksList = function() {
  return /** @type{!Array<!proto.risk.Risk>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.Risk, 1));
};


/**
 * @param {!Array<!proto.risk.Risk>} value
 * @return {!proto.risk.GetRisksResponse} returns this
*/
proto.risk.GetRisksResponse.prototype.setRisksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.Risk=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.Risk}
 */
proto.risk.GetRisksResponse.prototype.addRisks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.Risk, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.GetRisksResponse} returns this
 */
proto.risk.GetRisksResponse.prototype.clearRisksList = function() {
  return this.setRisksList([]);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.risk.GetRisksResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.GetRisksResponse} returns this
 */
proto.risk.GetRisksResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.GetRisksByIdsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.GetRisksByIdsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.GetRisksByIdsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.GetRisksByIdsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.GetRisksByIdsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.GetRisksByIdsRequest}
 */
proto.risk.GetRisksByIdsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.GetRisksByIdsRequest;
  return proto.risk.GetRisksByIdsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.GetRisksByIdsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.GetRisksByIdsRequest}
 */
proto.risk.GetRisksByIdsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addRiskIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.GetRisksByIdsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.GetRisksByIdsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.GetRisksByIdsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.GetRisksByIdsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string risk_ids = 1;
 * @return {!Array<string>}
 */
proto.risk.GetRisksByIdsRequest.prototype.getRiskIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.risk.GetRisksByIdsRequest} returns this
 */
proto.risk.GetRisksByIdsRequest.prototype.setRiskIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.risk.GetRisksByIdsRequest} returns this
 */
proto.risk.GetRisksByIdsRequest.prototype.addRiskIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.GetRisksByIdsRequest} returns this
 */
proto.risk.GetRisksByIdsRequest.prototype.clearRiskIdsList = function() {
  return this.setRiskIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.CreateOrUpdateRisksRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.CreateOrUpdateRisksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.CreateOrUpdateRisksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.CreateOrUpdateRisksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.CreateOrUpdateRisksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    risksList: jspb.Message.toObjectList(msg.getRisksList(),
    proto.risk.Risk.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.CreateOrUpdateRisksRequest}
 */
proto.risk.CreateOrUpdateRisksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.CreateOrUpdateRisksRequest;
  return proto.risk.CreateOrUpdateRisksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.CreateOrUpdateRisksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.CreateOrUpdateRisksRequest}
 */
proto.risk.CreateOrUpdateRisksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.Risk;
      reader.readMessage(value,proto.risk.Risk.deserializeBinaryFromReader);
      msg.addRisks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.CreateOrUpdateRisksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.CreateOrUpdateRisksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.CreateOrUpdateRisksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.CreateOrUpdateRisksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRisksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.Risk.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Risk risks = 1;
 * @return {!Array<!proto.risk.Risk>}
 */
proto.risk.CreateOrUpdateRisksRequest.prototype.getRisksList = function() {
  return /** @type{!Array<!proto.risk.Risk>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.Risk, 1));
};


/**
 * @param {!Array<!proto.risk.Risk>} value
 * @return {!proto.risk.CreateOrUpdateRisksRequest} returns this
*/
proto.risk.CreateOrUpdateRisksRequest.prototype.setRisksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.Risk=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.Risk}
 */
proto.risk.CreateOrUpdateRisksRequest.prototype.addRisks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.Risk, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.CreateOrUpdateRisksRequest} returns this
 */
proto.risk.CreateOrUpdateRisksRequest.prototype.clearRisksList = function() {
  return this.setRisksList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.ImportRisksRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.ImportRisksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.ImportRisksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.ImportRisksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ImportRisksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    risksList: jspb.Message.toObjectList(msg.getRisksList(),
    proto.risk.Risk.toObject, includeInstance),
    columnsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.ImportRisksRequest}
 */
proto.risk.ImportRisksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.ImportRisksRequest;
  return proto.risk.ImportRisksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.ImportRisksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.ImportRisksRequest}
 */
proto.risk.ImportRisksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.Risk;
      reader.readMessage(value,proto.risk.Risk.deserializeBinaryFromReader);
      msg.addRisks(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.risk.RISK_IMPORT_FIELD>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addColumns(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.ImportRisksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.ImportRisksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.ImportRisksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ImportRisksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRisksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.Risk.serializeBinaryToWriter
    );
  }
  f = message.getColumnsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
};


/**
 * repeated Risk risks = 1;
 * @return {!Array<!proto.risk.Risk>}
 */
proto.risk.ImportRisksRequest.prototype.getRisksList = function() {
  return /** @type{!Array<!proto.risk.Risk>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.Risk, 1));
};


/**
 * @param {!Array<!proto.risk.Risk>} value
 * @return {!proto.risk.ImportRisksRequest} returns this
*/
proto.risk.ImportRisksRequest.prototype.setRisksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.Risk=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.Risk}
 */
proto.risk.ImportRisksRequest.prototype.addRisks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.Risk, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.ImportRisksRequest} returns this
 */
proto.risk.ImportRisksRequest.prototype.clearRisksList = function() {
  return this.setRisksList([]);
};


/**
 * repeated RISK_IMPORT_FIELD columns = 2;
 * @return {!Array<!proto.risk.RISK_IMPORT_FIELD>}
 */
proto.risk.ImportRisksRequest.prototype.getColumnsList = function() {
  return /** @type {!Array<!proto.risk.RISK_IMPORT_FIELD>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.risk.RISK_IMPORT_FIELD>} value
 * @return {!proto.risk.ImportRisksRequest} returns this
 */
proto.risk.ImportRisksRequest.prototype.setColumnsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.risk.RISK_IMPORT_FIELD} value
 * @param {number=} opt_index
 * @return {!proto.risk.ImportRisksRequest} returns this
 */
proto.risk.ImportRisksRequest.prototype.addColumns = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.ImportRisksRequest} returns this
 */
proto.risk.ImportRisksRequest.prototype.clearColumnsList = function() {
  return this.setColumnsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.ImportRisksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.ImportRisksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.ImportRisksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ImportRisksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    created: jspb.Message.getFieldWithDefault(msg, 1, 0),
    updated: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.ImportRisksResponse}
 */
proto.risk.ImportRisksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.ImportRisksResponse;
  return proto.risk.ImportRisksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.ImportRisksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.ImportRisksResponse}
 */
proto.risk.ImportRisksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCreated(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUpdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.ImportRisksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.ImportRisksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.ImportRisksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ImportRisksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreated();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUpdated();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 created = 1;
 * @return {number}
 */
proto.risk.ImportRisksResponse.prototype.getCreated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.ImportRisksResponse} returns this
 */
proto.risk.ImportRisksResponse.prototype.setCreated = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 updated = 2;
 * @return {number}
 */
proto.risk.ImportRisksResponse.prototype.getUpdated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.ImportRisksResponse} returns this
 */
proto.risk.ImportRisksResponse.prototype.setUpdated = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.DeleteRisksRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.DeleteRisksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.DeleteRisksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.DeleteRisksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DeleteRisksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.DeleteRisksRequest}
 */
proto.risk.DeleteRisksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.DeleteRisksRequest;
  return proto.risk.DeleteRisksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.DeleteRisksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.DeleteRisksRequest}
 */
proto.risk.DeleteRisksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addRiskIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.DeleteRisksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.DeleteRisksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.DeleteRisksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DeleteRisksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string risk_ids = 1;
 * @return {!Array<string>}
 */
proto.risk.DeleteRisksRequest.prototype.getRiskIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.risk.DeleteRisksRequest} returns this
 */
proto.risk.DeleteRisksRequest.prototype.setRiskIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.risk.DeleteRisksRequest} returns this
 */
proto.risk.DeleteRisksRequest.prototype.addRiskIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.DeleteRisksRequest} returns this
 */
proto.risk.DeleteRisksRequest.prototype.clearRiskIdsList = function() {
  return this.setRiskIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskLink.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskLink.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskLink} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskLink.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    modelType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskLink}
 */
proto.risk.RiskLink.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskLink;
  return proto.risk.RiskLink.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskLink} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskLink}
 */
proto.risk.RiskLink.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.common.MODEL_TYPE} */ (reader.readEnum());
      msg.setModelType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskLink.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskLink.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskLink} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskLink.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getModelType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string risk_id = 1;
 * @return {string}
 */
proto.risk.RiskLink.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskLink} returns this
 */
proto.risk.RiskLink.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.risk.RiskLink.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskLink} returns this
 */
proto.risk.RiskLink.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.MODEL_TYPE model_type = 3;
 * @return {!proto.common.MODEL_TYPE}
 */
proto.risk.RiskLink.prototype.getModelType = function() {
  return /** @type {!proto.common.MODEL_TYPE} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.common.MODEL_TYPE} value
 * @return {!proto.risk.RiskLink} returns this
 */
proto.risk.RiskLink.prototype.setModelType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.ToggleRiskLinksRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.ToggleRiskLinksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.ToggleRiskLinksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.ToggleRiskLinksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ToggleRiskLinksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    linksList: jspb.Message.toObjectList(msg.getLinksList(),
    proto.risk.RiskLink.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.ToggleRiskLinksRequest}
 */
proto.risk.ToggleRiskLinksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.ToggleRiskLinksRequest;
  return proto.risk.ToggleRiskLinksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.ToggleRiskLinksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.ToggleRiskLinksRequest}
 */
proto.risk.ToggleRiskLinksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.risk.RISK_LINK_TYPE} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.risk.RiskLink;
      reader.readMessage(value,proto.risk.RiskLink.deserializeBinaryFromReader);
      msg.addLinks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.ToggleRiskLinksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.ToggleRiskLinksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.ToggleRiskLinksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ToggleRiskLinksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLinksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.risk.RiskLink.serializeBinaryToWriter
    );
  }
};


/**
 * optional RISK_LINK_TYPE type = 1;
 * @return {!proto.risk.RISK_LINK_TYPE}
 */
proto.risk.ToggleRiskLinksRequest.prototype.getType = function() {
  return /** @type {!proto.risk.RISK_LINK_TYPE} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.risk.RISK_LINK_TYPE} value
 * @return {!proto.risk.ToggleRiskLinksRequest} returns this
 */
proto.risk.ToggleRiskLinksRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated RiskLink links = 2;
 * @return {!Array<!proto.risk.RiskLink>}
 */
proto.risk.ToggleRiskLinksRequest.prototype.getLinksList = function() {
  return /** @type{!Array<!proto.risk.RiskLink>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskLink, 2));
};


/**
 * @param {!Array<!proto.risk.RiskLink>} value
 * @return {!proto.risk.ToggleRiskLinksRequest} returns this
*/
proto.risk.ToggleRiskLinksRequest.prototype.setLinksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.risk.RiskLink=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskLink}
 */
proto.risk.ToggleRiskLinksRequest.prototype.addLinks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.risk.RiskLink, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.ToggleRiskLinksRequest} returns this
 */
proto.risk.ToggleRiskLinksRequest.prototype.clearLinksList = function() {
  return this.setLinksList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.CreateOrUpdateRisksInternalRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.CreateOrUpdateRisksInternalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.CreateOrUpdateRisksInternalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.CreateOrUpdateRisksInternalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.CreateOrUpdateRisksInternalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    risksList: jspb.Message.toObjectList(msg.getRisksList(),
    proto.risk.Risk.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.CreateOrUpdateRisksInternalRequest}
 */
proto.risk.CreateOrUpdateRisksInternalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.CreateOrUpdateRisksInternalRequest;
  return proto.risk.CreateOrUpdateRisksInternalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.CreateOrUpdateRisksInternalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.CreateOrUpdateRisksInternalRequest}
 */
proto.risk.CreateOrUpdateRisksInternalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = new proto.risk.Risk;
      reader.readMessage(value,proto.risk.Risk.deserializeBinaryFromReader);
      msg.addRisks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.CreateOrUpdateRisksInternalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.CreateOrUpdateRisksInternalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.CreateOrUpdateRisksInternalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.CreateOrUpdateRisksInternalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRisksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.risk.Risk.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.risk.CreateOrUpdateRisksInternalRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.CreateOrUpdateRisksInternalRequest} returns this
 */
proto.risk.CreateOrUpdateRisksInternalRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.risk.CreateOrUpdateRisksInternalRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.CreateOrUpdateRisksInternalRequest} returns this
 */
proto.risk.CreateOrUpdateRisksInternalRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Risk risks = 3;
 * @return {!Array<!proto.risk.Risk>}
 */
proto.risk.CreateOrUpdateRisksInternalRequest.prototype.getRisksList = function() {
  return /** @type{!Array<!proto.risk.Risk>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.Risk, 3));
};


/**
 * @param {!Array<!proto.risk.Risk>} value
 * @return {!proto.risk.CreateOrUpdateRisksInternalRequest} returns this
*/
proto.risk.CreateOrUpdateRisksInternalRequest.prototype.setRisksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.risk.Risk=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.Risk}
 */
proto.risk.CreateOrUpdateRisksInternalRequest.prototype.addRisks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.risk.Risk, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.CreateOrUpdateRisksInternalRequest} returns this
 */
proto.risk.CreateOrUpdateRisksInternalRequest.prototype.clearRisksList = function() {
  return this.setRisksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.WrittenRisk.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.WrittenRisk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.WrittenRisk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.WrittenRisk.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    customId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    created: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.WrittenRisk}
 */
proto.risk.WrittenRisk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.WrittenRisk;
  return proto.risk.WrittenRisk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.WrittenRisk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.WrittenRisk}
 */
proto.risk.WrittenRisk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCreated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.WrittenRisk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.WrittenRisk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.WrittenRisk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.WrittenRisk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreated();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.risk.WrittenRisk.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.WrittenRisk} returns this
 */
proto.risk.WrittenRisk.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string custom_id = 2;
 * @return {string}
 */
proto.risk.WrittenRisk.prototype.getCustomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.WrittenRisk} returns this
 */
proto.risk.WrittenRisk.prototype.setCustomId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.risk.WrittenRisk.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.WrittenRisk} returns this
 */
proto.risk.WrittenRisk.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool created = 4;
 * @return {boolean}
 */
proto.risk.WrittenRisk.prototype.getCreated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.risk.WrittenRisk} returns this
 */
proto.risk.WrittenRisk.prototype.setCreated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.CreateOrUpdateRisksInternalResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.CreateOrUpdateRisksInternalResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.CreateOrUpdateRisksInternalResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.CreateOrUpdateRisksInternalResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.CreateOrUpdateRisksInternalResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    risksList: jspb.Message.toObjectList(msg.getRisksList(),
    proto.risk.WrittenRisk.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.CreateOrUpdateRisksInternalResponse}
 */
proto.risk.CreateOrUpdateRisksInternalResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.CreateOrUpdateRisksInternalResponse;
  return proto.risk.CreateOrUpdateRisksInternalResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.CreateOrUpdateRisksInternalResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.CreateOrUpdateRisksInternalResponse}
 */
proto.risk.CreateOrUpdateRisksInternalResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.WrittenRisk;
      reader.readMessage(value,proto.risk.WrittenRisk.deserializeBinaryFromReader);
      msg.addRisks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.CreateOrUpdateRisksInternalResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.CreateOrUpdateRisksInternalResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.CreateOrUpdateRisksInternalResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.CreateOrUpdateRisksInternalResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRisksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.WrittenRisk.serializeBinaryToWriter
    );
  }
};


/**
 * repeated WrittenRisk risks = 1;
 * @return {!Array<!proto.risk.WrittenRisk>}
 */
proto.risk.CreateOrUpdateRisksInternalResponse.prototype.getRisksList = function() {
  return /** @type{!Array<!proto.risk.WrittenRisk>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.WrittenRisk, 1));
};


/**
 * @param {!Array<!proto.risk.WrittenRisk>} value
 * @return {!proto.risk.CreateOrUpdateRisksInternalResponse} returns this
*/
proto.risk.CreateOrUpdateRisksInternalResponse.prototype.setRisksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.WrittenRisk=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.WrittenRisk}
 */
proto.risk.CreateOrUpdateRisksInternalResponse.prototype.addRisks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.WrittenRisk, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.CreateOrUpdateRisksInternalResponse} returns this
 */
proto.risk.CreateOrUpdateRisksInternalResponse.prototype.clearRisksList = function() {
  return this.setRisksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskEvaluationCriteriaDraft.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskEvaluationCriteriaDraft.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskEvaluationCriteriaDraft} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationCriteriaDraft.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    body: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskEvaluationCriteriaDraft}
 */
proto.risk.RiskEvaluationCriteriaDraft.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskEvaluationCriteriaDraft;
  return proto.risk.RiskEvaluationCriteriaDraft.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskEvaluationCriteriaDraft} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskEvaluationCriteriaDraft}
 */
proto.risk.RiskEvaluationCriteriaDraft.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskEvaluationCriteriaDraft.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskEvaluationCriteriaDraft.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskEvaluationCriteriaDraft} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationCriteriaDraft.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.risk.RiskEvaluationCriteriaDraft.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriteriaDraft} returns this
 */
proto.risk.RiskEvaluationCriteriaDraft.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string body = 2;
 * @return {string}
 */
proto.risk.RiskEvaluationCriteriaDraft.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriteriaDraft} returns this
 */
proto.risk.RiskEvaluationCriteriaDraft.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.SetRiskEvaluationCriteriaInternalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    riskId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    criteriaList: jspb.Message.toObjectList(msg.getCriteriaList(),
    proto.risk.RiskEvaluationCriteriaDraft.toObject, includeInstance),
    replaceExisting: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.SetRiskEvaluationCriteriaInternalRequest}
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.SetRiskEvaluationCriteriaInternalRequest;
  return proto.risk.SetRiskEvaluationCriteriaInternalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.SetRiskEvaluationCriteriaInternalRequest}
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    case 4:
      var value = new proto.risk.RiskEvaluationCriteriaDraft;
      reader.readMessage(value,proto.risk.RiskEvaluationCriteriaDraft.deserializeBinaryFromReader);
      msg.addCriteria(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReplaceExisting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.SetRiskEvaluationCriteriaInternalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCriteriaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.risk.RiskEvaluationCriteriaDraft.serializeBinaryToWriter
    );
  }
  f = message.getReplaceExisting();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} returns this
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} returns this
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string risk_id = 3;
 * @return {string}
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} returns this
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated RiskEvaluationCriteriaDraft criteria = 4;
 * @return {!Array<!proto.risk.RiskEvaluationCriteriaDraft>}
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.getCriteriaList = function() {
  return /** @type{!Array<!proto.risk.RiskEvaluationCriteriaDraft>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskEvaluationCriteriaDraft, 4));
};


/**
 * @param {!Array<!proto.risk.RiskEvaluationCriteriaDraft>} value
 * @return {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} returns this
*/
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.setCriteriaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.risk.RiskEvaluationCriteriaDraft=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskEvaluationCriteriaDraft}
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.addCriteria = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.risk.RiskEvaluationCriteriaDraft, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} returns this
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.clearCriteriaList = function() {
  return this.setCriteriaList([]);
};


/**
 * optional bool replace_existing = 5;
 * @return {boolean}
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.getReplaceExisting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} returns this
 */
proto.risk.SetRiskEvaluationCriteriaInternalRequest.prototype.setReplaceExisting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.ToggleRiskLinksInternalRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.ToggleRiskLinksInternalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.ToggleRiskLinksInternalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.ToggleRiskLinksInternalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ToggleRiskLinksInternalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    linksList: jspb.Message.toObjectList(msg.getLinksList(),
    proto.risk.RiskLink.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.ToggleRiskLinksInternalRequest}
 */
proto.risk.ToggleRiskLinksInternalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.ToggleRiskLinksInternalRequest;
  return proto.risk.ToggleRiskLinksInternalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.ToggleRiskLinksInternalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.ToggleRiskLinksInternalRequest}
 */
proto.risk.ToggleRiskLinksInternalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {!proto.risk.RISK_LINK_TYPE} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = new proto.risk.RiskLink;
      reader.readMessage(value,proto.risk.RiskLink.deserializeBinaryFromReader);
      msg.addLinks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.ToggleRiskLinksInternalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.ToggleRiskLinksInternalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.ToggleRiskLinksInternalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ToggleRiskLinksInternalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getLinksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.risk.RiskLink.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.risk.ToggleRiskLinksInternalRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.ToggleRiskLinksInternalRequest} returns this
 */
proto.risk.ToggleRiskLinksInternalRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.risk.ToggleRiskLinksInternalRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.ToggleRiskLinksInternalRequest} returns this
 */
proto.risk.ToggleRiskLinksInternalRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RISK_LINK_TYPE type = 3;
 * @return {!proto.risk.RISK_LINK_TYPE}
 */
proto.risk.ToggleRiskLinksInternalRequest.prototype.getType = function() {
  return /** @type {!proto.risk.RISK_LINK_TYPE} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.risk.RISK_LINK_TYPE} value
 * @return {!proto.risk.ToggleRiskLinksInternalRequest} returns this
 */
proto.risk.ToggleRiskLinksInternalRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated RiskLink links = 4;
 * @return {!Array<!proto.risk.RiskLink>}
 */
proto.risk.ToggleRiskLinksInternalRequest.prototype.getLinksList = function() {
  return /** @type{!Array<!proto.risk.RiskLink>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskLink, 4));
};


/**
 * @param {!Array<!proto.risk.RiskLink>} value
 * @return {!proto.risk.ToggleRiskLinksInternalRequest} returns this
*/
proto.risk.ToggleRiskLinksInternalRequest.prototype.setLinksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.risk.RiskLink=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskLink}
 */
proto.risk.ToggleRiskLinksInternalRequest.prototype.addLinks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.risk.RiskLink, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.ToggleRiskLinksInternalRequest} returns this
 */
proto.risk.ToggleRiskLinksInternalRequest.prototype.clearLinksList = function() {
  return this.setLinksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.DownloadRiskCSVRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.DownloadRiskCSVRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.DownloadRiskCSVRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DownloadRiskCSVRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    filterBy: (f = msg.getFilterBy()) && proto.risk.RiskFilter.toObject(includeInstance, f),
    sortBy: (f = msg.getSortBy()) && proto.risk.RiskSort.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.DownloadRiskCSVRequest}
 */
proto.risk.DownloadRiskCSVRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.DownloadRiskCSVRequest;
  return proto.risk.DownloadRiskCSVRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.DownloadRiskCSVRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.DownloadRiskCSVRequest}
 */
proto.risk.DownloadRiskCSVRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.RiskFilter;
      reader.readMessage(value,proto.risk.RiskFilter.deserializeBinaryFromReader);
      msg.setFilterBy(value);
      break;
    case 2:
      var value = new proto.risk.RiskSort;
      reader.readMessage(value,proto.risk.RiskSort.deserializeBinaryFromReader);
      msg.setSortBy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.DownloadRiskCSVRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.DownloadRiskCSVRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.DownloadRiskCSVRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DownloadRiskCSVRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilterBy();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.risk.RiskFilter.serializeBinaryToWriter
    );
  }
  f = message.getSortBy();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.risk.RiskSort.serializeBinaryToWriter
    );
  }
};


/**
 * optional RiskFilter filter_by = 1;
 * @return {?proto.risk.RiskFilter}
 */
proto.risk.DownloadRiskCSVRequest.prototype.getFilterBy = function() {
  return /** @type{?proto.risk.RiskFilter} */ (
    jspb.Message.getWrapperField(this, proto.risk.RiskFilter, 1));
};


/**
 * @param {?proto.risk.RiskFilter|undefined} value
 * @return {!proto.risk.DownloadRiskCSVRequest} returns this
*/
proto.risk.DownloadRiskCSVRequest.prototype.setFilterBy = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.risk.DownloadRiskCSVRequest} returns this
 */
proto.risk.DownloadRiskCSVRequest.prototype.clearFilterBy = function() {
  return this.setFilterBy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.risk.DownloadRiskCSVRequest.prototype.hasFilterBy = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RiskSort sort_by = 2;
 * @return {?proto.risk.RiskSort}
 */
proto.risk.DownloadRiskCSVRequest.prototype.getSortBy = function() {
  return /** @type{?proto.risk.RiskSort} */ (
    jspb.Message.getWrapperField(this, proto.risk.RiskSort, 2));
};


/**
 * @param {?proto.risk.RiskSort|undefined} value
 * @return {!proto.risk.DownloadRiskCSVRequest} returns this
*/
proto.risk.DownloadRiskCSVRequest.prototype.setSortBy = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.risk.DownloadRiskCSVRequest} returns this
 */
proto.risk.DownloadRiskCSVRequest.prototype.clearSortBy = function() {
  return this.setSortBy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.risk.DownloadRiskCSVRequest.prototype.hasSortBy = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.DownloadRiskCSVResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.DownloadRiskCSVResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.DownloadRiskCSVResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DownloadRiskCSVResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.DownloadRiskCSVResponse}
 */
proto.risk.DownloadRiskCSVResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.DownloadRiskCSVResponse;
  return proto.risk.DownloadRiskCSVResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.DownloadRiskCSVResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.DownloadRiskCSVResponse}
 */
proto.risk.DownloadRiskCSVResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.DownloadRiskCSVResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.DownloadRiskCSVResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.DownloadRiskCSVResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DownloadRiskCSVResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.GetRiskCategoryOptionResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.GetRiskCategoryOptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.GetRiskCategoryOptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.GetRiskCategoryOptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.GetRiskCategoryOptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.risk.RiskCategoryOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.GetRiskCategoryOptionResponse}
 */
proto.risk.GetRiskCategoryOptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.GetRiskCategoryOptionResponse;
  return proto.risk.GetRiskCategoryOptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.GetRiskCategoryOptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.GetRiskCategoryOptionResponse}
 */
proto.risk.GetRiskCategoryOptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.RiskCategoryOption;
      reader.readMessage(value,proto.risk.RiskCategoryOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.GetRiskCategoryOptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.GetRiskCategoryOptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.GetRiskCategoryOptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.GetRiskCategoryOptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.RiskCategoryOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RiskCategoryOption options = 1;
 * @return {!Array<!proto.risk.RiskCategoryOption>}
 */
proto.risk.GetRiskCategoryOptionResponse.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.risk.RiskCategoryOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskCategoryOption, 1));
};


/**
 * @param {!Array<!proto.risk.RiskCategoryOption>} value
 * @return {!proto.risk.GetRiskCategoryOptionResponse} returns this
*/
proto.risk.GetRiskCategoryOptionResponse.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.RiskCategoryOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskCategoryOption}
 */
proto.risk.GetRiskCategoryOptionResponse.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.RiskCategoryOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.GetRiskCategoryOptionResponse} returns this
 */
proto.risk.GetRiskCategoryOptionResponse.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskCategoryOption.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskCategoryOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskCategoryOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskCategoryOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, 0),
    sortOrder: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskCategoryOption}
 */
proto.risk.RiskCategoryOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskCategoryOption;
  return proto.risk.RiskCategoryOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskCategoryOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskCategoryOption}
 */
proto.risk.RiskCategoryOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskCategoryOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskCategoryOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskCategoryOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskCategoryOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.risk.RiskCategoryOption.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskCategoryOption} returns this
 */
proto.risk.RiskCategoryOption.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.risk.RiskCategoryOption.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskCategoryOption} returns this
 */
proto.risk.RiskCategoryOption.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 value = 3;
 * @return {number}
 */
proto.risk.RiskCategoryOption.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.RiskCategoryOption} returns this
 */
proto.risk.RiskCategoryOption.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 sort_order = 4;
 * @return {number}
 */
proto.risk.RiskCategoryOption.prototype.getSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.RiskCategoryOption} returns this
 */
proto.risk.RiskCategoryOption.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.DeleteRiskCategoryOptionRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.DeleteRiskCategoryOptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.DeleteRiskCategoryOptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.DeleteRiskCategoryOptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DeleteRiskCategoryOptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    idList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.DeleteRiskCategoryOptionRequest}
 */
proto.risk.DeleteRiskCategoryOptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.DeleteRiskCategoryOptionRequest;
  return proto.risk.DeleteRiskCategoryOptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.DeleteRiskCategoryOptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.DeleteRiskCategoryOptionRequest}
 */
proto.risk.DeleteRiskCategoryOptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addId(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.DeleteRiskCategoryOptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.DeleteRiskCategoryOptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.DeleteRiskCategoryOptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DeleteRiskCategoryOptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 id = 1;
 * @return {!Array<number>}
 */
proto.risk.DeleteRiskCategoryOptionRequest.prototype.getIdList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.risk.DeleteRiskCategoryOptionRequest} returns this
 */
proto.risk.DeleteRiskCategoryOptionRequest.prototype.setIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.risk.DeleteRiskCategoryOptionRequest} returns this
 */
proto.risk.DeleteRiskCategoryOptionRequest.prototype.addId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.DeleteRiskCategoryOptionRequest} returns this
 */
proto.risk.DeleteRiskCategoryOptionRequest.prototype.clearIdList = function() {
  return this.setIdList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.UpsertRiskCategoryOptionRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.UpsertRiskCategoryOptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.UpsertRiskCategoryOptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.UpsertRiskCategoryOptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.UpsertRiskCategoryOptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    optionList: jspb.Message.toObjectList(msg.getOptionList(),
    proto.risk.RiskCategoryOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.UpsertRiskCategoryOptionRequest}
 */
proto.risk.UpsertRiskCategoryOptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.UpsertRiskCategoryOptionRequest;
  return proto.risk.UpsertRiskCategoryOptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.UpsertRiskCategoryOptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.UpsertRiskCategoryOptionRequest}
 */
proto.risk.UpsertRiskCategoryOptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.RiskCategoryOption;
      reader.readMessage(value,proto.risk.RiskCategoryOption.deserializeBinaryFromReader);
      msg.addOption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.UpsertRiskCategoryOptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.UpsertRiskCategoryOptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.UpsertRiskCategoryOptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.UpsertRiskCategoryOptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.RiskCategoryOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RiskCategoryOption option = 1;
 * @return {!Array<!proto.risk.RiskCategoryOption>}
 */
proto.risk.UpsertRiskCategoryOptionRequest.prototype.getOptionList = function() {
  return /** @type{!Array<!proto.risk.RiskCategoryOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskCategoryOption, 1));
};


/**
 * @param {!Array<!proto.risk.RiskCategoryOption>} value
 * @return {!proto.risk.UpsertRiskCategoryOptionRequest} returns this
*/
proto.risk.UpsertRiskCategoryOptionRequest.prototype.setOptionList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.RiskCategoryOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskCategoryOption}
 */
proto.risk.UpsertRiskCategoryOptionRequest.prototype.addOption = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.RiskCategoryOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.UpsertRiskCategoryOptionRequest} returns this
 */
proto.risk.UpsertRiskCategoryOptionRequest.prototype.clearOptionList = function() {
  return this.setOptionList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskEvaluationCriteria.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskEvaluationCriteria.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskEvaluationCriteria} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationCriteria.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    riskId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    body: jspb.Message.getFieldWithDefault(msg, 4, ""),
    position: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskEvaluationCriteria}
 */
proto.risk.RiskEvaluationCriteria.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskEvaluationCriteria;
  return proto.risk.RiskEvaluationCriteria.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskEvaluationCriteria} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskEvaluationCriteria}
 */
proto.risk.RiskEvaluationCriteria.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskEvaluationCriteria.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskEvaluationCriteria.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskEvaluationCriteria} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationCriteria.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.risk.RiskEvaluationCriteria.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriteria} returns this
 */
proto.risk.RiskEvaluationCriteria.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string risk_id = 2;
 * @return {string}
 */
proto.risk.RiskEvaluationCriteria.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriteria} returns this
 */
proto.risk.RiskEvaluationCriteria.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.risk.RiskEvaluationCriteria.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriteria} returns this
 */
proto.risk.RiskEvaluationCriteria.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string body = 4;
 * @return {string}
 */
proto.risk.RiskEvaluationCriteria.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriteria} returns this
 */
proto.risk.RiskEvaluationCriteria.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 position = 5;
 * @return {number}
 */
proto.risk.RiskEvaluationCriteria.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.RiskEvaluationCriteria} returns this
 */
proto.risk.RiskEvaluationCriteria.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.EvaluateRiskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.EvaluateRiskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.EvaluateRiskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.EvaluateRiskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.EvaluateRiskRequest}
 */
proto.risk.EvaluateRiskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.EvaluateRiskRequest;
  return proto.risk.EvaluateRiskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.EvaluateRiskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.EvaluateRiskRequest}
 */
proto.risk.EvaluateRiskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.EvaluateRiskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.EvaluateRiskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.EvaluateRiskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.EvaluateRiskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string risk_id = 1;
 * @return {string}
 */
proto.risk.EvaluateRiskRequest.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.EvaluateRiskRequest} returns this
 */
proto.risk.EvaluateRiskRequest.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.ListRiskEvaluationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.ListRiskEvaluationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.ListRiskEvaluationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    includeCriteria: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.ListRiskEvaluationsRequest}
 */
proto.risk.ListRiskEvaluationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.ListRiskEvaluationsRequest;
  return proto.risk.ListRiskEvaluationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.ListRiskEvaluationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.ListRiskEvaluationsRequest}
 */
proto.risk.ListRiskEvaluationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeCriteria(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.ListRiskEvaluationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.ListRiskEvaluationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.ListRiskEvaluationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIncludeCriteria();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string risk_id = 1;
 * @return {string}
 */
proto.risk.ListRiskEvaluationsRequest.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.ListRiskEvaluationsRequest} returns this
 */
proto.risk.ListRiskEvaluationsRequest.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool include_criteria = 2;
 * @return {boolean}
 */
proto.risk.ListRiskEvaluationsRequest.prototype.getIncludeCriteria = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.risk.ListRiskEvaluationsRequest} returns this
 */
proto.risk.ListRiskEvaluationsRequest.prototype.setIncludeCriteria = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.ListRiskEvaluationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.ListRiskEvaluationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.ListRiskEvaluationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.ListRiskEvaluationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    evaluationsList: jspb.Message.toObjectList(msg.getEvaluationsList(),
    proto.risk.RiskEvaluationResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.ListRiskEvaluationsResponse}
 */
proto.risk.ListRiskEvaluationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.ListRiskEvaluationsResponse;
  return proto.risk.ListRiskEvaluationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.ListRiskEvaluationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.ListRiskEvaluationsResponse}
 */
proto.risk.ListRiskEvaluationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.RiskEvaluationResult;
      reader.readMessage(value,proto.risk.RiskEvaluationResult.deserializeBinaryFromReader);
      msg.addEvaluations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.ListRiskEvaluationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.ListRiskEvaluationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.ListRiskEvaluationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvaluationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.RiskEvaluationResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RiskEvaluationResult evaluations = 1;
 * @return {!Array<!proto.risk.RiskEvaluationResult>}
 */
proto.risk.ListRiskEvaluationsResponse.prototype.getEvaluationsList = function() {
  return /** @type{!Array<!proto.risk.RiskEvaluationResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskEvaluationResult, 1));
};


/**
 * @param {!Array<!proto.risk.RiskEvaluationResult>} value
 * @return {!proto.risk.ListRiskEvaluationsResponse} returns this
*/
proto.risk.ListRiskEvaluationsResponse.prototype.setEvaluationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.RiskEvaluationResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskEvaluationResult}
 */
proto.risk.ListRiskEvaluationsResponse.prototype.addEvaluations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.RiskEvaluationResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.ListRiskEvaluationsResponse} returns this
 */
proto.risk.ListRiskEvaluationsResponse.prototype.clearEvaluationsList = function() {
  return this.setEvaluationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.RiskEvaluationResult.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskEvaluationResult.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskEvaluationResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskEvaluationResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    riskId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    percentage: jspb.Message.getFieldWithDefault(msg, 3, 0),
    band: jspb.Message.getFieldWithDefault(msg, 4, ""),
    residualLikelihood: jspb.Message.getFieldWithDefault(msg, 5, 0),
    residualAdverseImpact: jspb.Message.getFieldWithDefault(msg, 6, 0),
    rationale: jspb.Message.getFieldWithDefault(msg, 7, ""),
    criteriaList: jspb.Message.toObjectList(msg.getCriteriaList(),
    proto.risk.RiskEvaluationCriterionResult.toObject, includeInstance),
    artifactId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    evaluatedAt: jspb.Message.getFieldWithDefault(msg, 10, 0),
    evaluatedBy: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskEvaluationResult}
 */
proto.risk.RiskEvaluationResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskEvaluationResult;
  return proto.risk.RiskEvaluationResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskEvaluationResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskEvaluationResult}
 */
proto.risk.RiskEvaluationResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPercentage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBand(value);
      break;
    case 5:
      var value = /** @type {!proto.risk.RISK_MATH} */ (reader.readEnum());
      msg.setResidualLikelihood(value);
      break;
    case 6:
      var value = /** @type {!proto.risk.RISK_MATH} */ (reader.readEnum());
      msg.setResidualAdverseImpact(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRationale(value);
      break;
    case 8:
      var value = new proto.risk.RiskEvaluationCriterionResult;
      reader.readMessage(value,proto.risk.RiskEvaluationCriterionResult.deserializeBinaryFromReader);
      msg.addCriteria(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setArtifactId(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEvaluatedAt(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvaluatedBy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskEvaluationResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskEvaluationResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskEvaluationResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPercentage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBand();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getResidualLikelihood();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getResidualAdverseImpact();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getRationale();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCriteriaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.risk.RiskEvaluationCriterionResult.serializeBinaryToWriter
    );
  }
  f = message.getArtifactId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEvaluatedAt();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getEvaluatedBy();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.risk.RiskEvaluationResult.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationResult} returns this
 */
proto.risk.RiskEvaluationResult.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string risk_id = 2;
 * @return {string}
 */
proto.risk.RiskEvaluationResult.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationResult} returns this
 */
proto.risk.RiskEvaluationResult.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 percentage = 3;
 * @return {number}
 */
proto.risk.RiskEvaluationResult.prototype.getPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.RiskEvaluationResult} returns this
 */
proto.risk.RiskEvaluationResult.prototype.setPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string band = 4;
 * @return {string}
 */
proto.risk.RiskEvaluationResult.prototype.getBand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationResult} returns this
 */
proto.risk.RiskEvaluationResult.prototype.setBand = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional RISK_MATH residual_likelihood = 5;
 * @return {!proto.risk.RISK_MATH}
 */
proto.risk.RiskEvaluationResult.prototype.getResidualLikelihood = function() {
  return /** @type {!proto.risk.RISK_MATH} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.risk.RISK_MATH} value
 * @return {!proto.risk.RiskEvaluationResult} returns this
 */
proto.risk.RiskEvaluationResult.prototype.setResidualLikelihood = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional RISK_MATH residual_adverse_impact = 6;
 * @return {!proto.risk.RISK_MATH}
 */
proto.risk.RiskEvaluationResult.prototype.getResidualAdverseImpact = function() {
  return /** @type {!proto.risk.RISK_MATH} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.risk.RISK_MATH} value
 * @return {!proto.risk.RiskEvaluationResult} returns this
 */
proto.risk.RiskEvaluationResult.prototype.setResidualAdverseImpact = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string rationale = 7;
 * @return {string}
 */
proto.risk.RiskEvaluationResult.prototype.getRationale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationResult} returns this
 */
proto.risk.RiskEvaluationResult.prototype.setRationale = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated RiskEvaluationCriterionResult criteria = 8;
 * @return {!Array<!proto.risk.RiskEvaluationCriterionResult>}
 */
proto.risk.RiskEvaluationResult.prototype.getCriteriaList = function() {
  return /** @type{!Array<!proto.risk.RiskEvaluationCriterionResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskEvaluationCriterionResult, 8));
};


/**
 * @param {!Array<!proto.risk.RiskEvaluationCriterionResult>} value
 * @return {!proto.risk.RiskEvaluationResult} returns this
*/
proto.risk.RiskEvaluationResult.prototype.setCriteriaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.risk.RiskEvaluationCriterionResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskEvaluationCriterionResult}
 */
proto.risk.RiskEvaluationResult.prototype.addCriteria = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.risk.RiskEvaluationCriterionResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskEvaluationResult} returns this
 */
proto.risk.RiskEvaluationResult.prototype.clearCriteriaList = function() {
  return this.setCriteriaList([]);
};


/**
 * optional string artifact_id = 9;
 * @return {string}
 */
proto.risk.RiskEvaluationResult.prototype.getArtifactId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationResult} returns this
 */
proto.risk.RiskEvaluationResult.prototype.setArtifactId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 evaluated_at = 10;
 * @return {number}
 */
proto.risk.RiskEvaluationResult.prototype.getEvaluatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.RiskEvaluationResult} returns this
 */
proto.risk.RiskEvaluationResult.prototype.setEvaluatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string evaluated_by = 11;
 * @return {string}
 */
proto.risk.RiskEvaluationResult.prototype.getEvaluatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationResult} returns this
 */
proto.risk.RiskEvaluationResult.prototype.setEvaluatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskEvaluationCriterionResult.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskEvaluationCriterionResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskEvaluationCriterionResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationCriterionResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    criterionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    outcome: jspb.Message.getFieldWithDefault(msg, 3, ""),
    reason: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskEvaluationCriterionResult}
 */
proto.risk.RiskEvaluationCriterionResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskEvaluationCriterionResult;
  return proto.risk.RiskEvaluationCriterionResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskEvaluationCriterionResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskEvaluationCriterionResult}
 */
proto.risk.RiskEvaluationCriterionResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCriterionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutcome(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskEvaluationCriterionResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskEvaluationCriterionResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskEvaluationCriterionResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationCriterionResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCriterionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOutcome();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string criterion_id = 1;
 * @return {string}
 */
proto.risk.RiskEvaluationCriterionResult.prototype.getCriterionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriterionResult} returns this
 */
proto.risk.RiskEvaluationCriterionResult.prototype.setCriterionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.risk.RiskEvaluationCriterionResult.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriterionResult} returns this
 */
proto.risk.RiskEvaluationCriterionResult.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string outcome = 3;
 * @return {string}
 */
proto.risk.RiskEvaluationCriterionResult.prototype.getOutcome = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriterionResult} returns this
 */
proto.risk.RiskEvaluationCriterionResult.prototype.setOutcome = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string reason = 4;
 * @return {string}
 */
proto.risk.RiskEvaluationCriterionResult.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriterionResult} returns this
 */
proto.risk.RiskEvaluationCriterionResult.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.ListRiskEvaluationCriteriaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.ListRiskEvaluationCriteriaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.ListRiskEvaluationCriteriaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationCriteriaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.ListRiskEvaluationCriteriaRequest}
 */
proto.risk.ListRiskEvaluationCriteriaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.ListRiskEvaluationCriteriaRequest;
  return proto.risk.ListRiskEvaluationCriteriaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.ListRiskEvaluationCriteriaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.ListRiskEvaluationCriteriaRequest}
 */
proto.risk.ListRiskEvaluationCriteriaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.ListRiskEvaluationCriteriaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.ListRiskEvaluationCriteriaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.ListRiskEvaluationCriteriaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationCriteriaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string risk_id = 1;
 * @return {string}
 */
proto.risk.ListRiskEvaluationCriteriaRequest.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.ListRiskEvaluationCriteriaRequest} returns this
 */
proto.risk.ListRiskEvaluationCriteriaRequest.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.ListRiskEvaluationCriteriaResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.ListRiskEvaluationCriteriaResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.ListRiskEvaluationCriteriaResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.ListRiskEvaluationCriteriaResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationCriteriaResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.risk.RiskEvaluationCriteria.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.ListRiskEvaluationCriteriaResponse}
 */
proto.risk.ListRiskEvaluationCriteriaResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.ListRiskEvaluationCriteriaResponse;
  return proto.risk.ListRiskEvaluationCriteriaResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.ListRiskEvaluationCriteriaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.ListRiskEvaluationCriteriaResponse}
 */
proto.risk.ListRiskEvaluationCriteriaResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.RiskEvaluationCriteria;
      reader.readMessage(value,proto.risk.RiskEvaluationCriteria.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.ListRiskEvaluationCriteriaResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.ListRiskEvaluationCriteriaResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.ListRiskEvaluationCriteriaResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationCriteriaResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.RiskEvaluationCriteria.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RiskEvaluationCriteria items = 1;
 * @return {!Array<!proto.risk.RiskEvaluationCriteria>}
 */
proto.risk.ListRiskEvaluationCriteriaResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.risk.RiskEvaluationCriteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskEvaluationCriteria, 1));
};


/**
 * @param {!Array<!proto.risk.RiskEvaluationCriteria>} value
 * @return {!proto.risk.ListRiskEvaluationCriteriaResponse} returns this
*/
proto.risk.ListRiskEvaluationCriteriaResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.RiskEvaluationCriteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskEvaluationCriteria}
 */
proto.risk.ListRiskEvaluationCriteriaResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.RiskEvaluationCriteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.ListRiskEvaluationCriteriaResponse} returns this
 */
proto.risk.ListRiskEvaluationCriteriaResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.CreateRiskEvaluationCriteriaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.CreateRiskEvaluationCriteriaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    body: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.CreateRiskEvaluationCriteriaRequest}
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.CreateRiskEvaluationCriteriaRequest;
  return proto.risk.CreateRiskEvaluationCriteriaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.CreateRiskEvaluationCriteriaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.CreateRiskEvaluationCriteriaRequest}
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.CreateRiskEvaluationCriteriaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.CreateRiskEvaluationCriteriaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string risk_id = 1;
 * @return {string}
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.CreateRiskEvaluationCriteriaRequest} returns this
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.CreateRiskEvaluationCriteriaRequest} returns this
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string body = 3;
 * @return {string}
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.CreateRiskEvaluationCriteriaRequest} returns this
 */
proto.risk.CreateRiskEvaluationCriteriaRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.UpdateRiskEvaluationCriteriaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.UpdateRiskEvaluationCriteriaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    evaluationCriteriaId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: (f = msg.getTitle()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    body: (f = msg.getBody()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    position: (f = msg.getPosition()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.UpdateRiskEvaluationCriteriaRequest}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.UpdateRiskEvaluationCriteriaRequest;
  return proto.risk.UpdateRiskEvaluationCriteriaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.UpdateRiskEvaluationCriteriaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.UpdateRiskEvaluationCriteriaRequest}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvaluationCriteriaId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setTitle(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.UpdateRiskEvaluationCriteriaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.UpdateRiskEvaluationCriteriaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEvaluationCriteriaId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string risk_id = 1;
 * @return {string}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.UpdateRiskEvaluationCriteriaRequest} returns this
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string evaluation_criteria_id = 2;
 * @return {string}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.getEvaluationCriteriaId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.UpdateRiskEvaluationCriteriaRequest} returns this
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.setEvaluationCriteriaId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue title = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.getTitle = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.risk.UpdateRiskEvaluationCriteriaRequest} returns this
*/
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.setTitle = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.risk.UpdateRiskEvaluationCriteriaRequest} returns this
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.clearTitle = function() {
  return this.setTitle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.hasTitle = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue body = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.getBody = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.risk.UpdateRiskEvaluationCriteriaRequest} returns this
*/
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.risk.UpdateRiskEvaluationCriteriaRequest} returns this
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.hasBody = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Int32Value position = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.getPosition = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.risk.UpdateRiskEvaluationCriteriaRequest} returns this
*/
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.risk.UpdateRiskEvaluationCriteriaRequest} returns this
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.risk.UpdateRiskEvaluationCriteriaRequest.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.DeleteRiskEvaluationCriteriaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.DeleteRiskEvaluationCriteriaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.DeleteRiskEvaluationCriteriaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DeleteRiskEvaluationCriteriaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    evaluationCriteriaId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.DeleteRiskEvaluationCriteriaRequest}
 */
proto.risk.DeleteRiskEvaluationCriteriaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.DeleteRiskEvaluationCriteriaRequest;
  return proto.risk.DeleteRiskEvaluationCriteriaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.DeleteRiskEvaluationCriteriaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.DeleteRiskEvaluationCriteriaRequest}
 */
proto.risk.DeleteRiskEvaluationCriteriaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvaluationCriteriaId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.DeleteRiskEvaluationCriteriaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.DeleteRiskEvaluationCriteriaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.DeleteRiskEvaluationCriteriaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DeleteRiskEvaluationCriteriaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEvaluationCriteriaId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string risk_id = 1;
 * @return {string}
 */
proto.risk.DeleteRiskEvaluationCriteriaRequest.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.DeleteRiskEvaluationCriteriaRequest} returns this
 */
proto.risk.DeleteRiskEvaluationCriteriaRequest.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string evaluation_criteria_id = 2;
 * @return {string}
 */
proto.risk.DeleteRiskEvaluationCriteriaRequest.prototype.getEvaluationCriteriaId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.DeleteRiskEvaluationCriteriaRequest} returns this
 */
proto.risk.DeleteRiskEvaluationCriteriaRequest.prototype.setEvaluationCriteriaId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskEvaluationCriteriaVersionItem.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskEvaluationCriteriaVersionItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskEvaluationCriteriaVersionItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationCriteriaVersionItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    evaluationCriteriaId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    body: jspb.Message.getFieldWithDefault(msg, 3, ""),
    position: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskEvaluationCriteriaVersionItem}
 */
proto.risk.RiskEvaluationCriteriaVersionItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskEvaluationCriteriaVersionItem;
  return proto.risk.RiskEvaluationCriteriaVersionItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskEvaluationCriteriaVersionItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskEvaluationCriteriaVersionItem}
 */
proto.risk.RiskEvaluationCriteriaVersionItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvaluationCriteriaId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskEvaluationCriteriaVersionItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskEvaluationCriteriaVersionItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskEvaluationCriteriaVersionItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationCriteriaVersionItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvaluationCriteriaId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string evaluation_criteria_id = 1;
 * @return {string}
 */
proto.risk.RiskEvaluationCriteriaVersionItem.prototype.getEvaluationCriteriaId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriteriaVersionItem} returns this
 */
proto.risk.RiskEvaluationCriteriaVersionItem.prototype.setEvaluationCriteriaId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.risk.RiskEvaluationCriteriaVersionItem.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriteriaVersionItem} returns this
 */
proto.risk.RiskEvaluationCriteriaVersionItem.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string body = 3;
 * @return {string}
 */
proto.risk.RiskEvaluationCriteriaVersionItem.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriteriaVersionItem} returns this
 */
proto.risk.RiskEvaluationCriteriaVersionItem.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 position = 4;
 * @return {number}
 */
proto.risk.RiskEvaluationCriteriaVersionItem.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.RiskEvaluationCriteriaVersionItem} returns this
 */
proto.risk.RiskEvaluationCriteriaVersionItem.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.RiskEvaluationCriteriaVersion.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskEvaluationCriteriaVersion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskEvaluationCriteriaVersion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationCriteriaVersion.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    riskId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.risk.RiskEvaluationCriteriaVersionItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskEvaluationCriteriaVersion}
 */
proto.risk.RiskEvaluationCriteriaVersion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskEvaluationCriteriaVersion;
  return proto.risk.RiskEvaluationCriteriaVersion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskEvaluationCriteriaVersion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskEvaluationCriteriaVersion}
 */
proto.risk.RiskEvaluationCriteriaVersion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = new proto.risk.RiskEvaluationCriteriaVersionItem;
      reader.readMessage(value,proto.risk.RiskEvaluationCriteriaVersionItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskEvaluationCriteriaVersion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskEvaluationCriteriaVersion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskEvaluationCriteriaVersion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.risk.RiskEvaluationCriteriaVersionItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriteriaVersion} returns this
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string risk_id = 2;
 * @return {string}
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskEvaluationCriteriaVersion} returns this
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.risk.RiskEvaluationCriteriaVersion} returns this
*/
proto.risk.RiskEvaluationCriteriaVersion.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.risk.RiskEvaluationCriteriaVersion} returns this
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated RiskEvaluationCriteriaVersionItem items = 4;
 * @return {!Array<!proto.risk.RiskEvaluationCriteriaVersionItem>}
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.risk.RiskEvaluationCriteriaVersionItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskEvaluationCriteriaVersionItem, 4));
};


/**
 * @param {!Array<!proto.risk.RiskEvaluationCriteriaVersionItem>} value
 * @return {!proto.risk.RiskEvaluationCriteriaVersion} returns this
*/
proto.risk.RiskEvaluationCriteriaVersion.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.risk.RiskEvaluationCriteriaVersionItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskEvaluationCriteriaVersionItem}
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.risk.RiskEvaluationCriteriaVersionItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskEvaluationCriteriaVersion} returns this
 */
proto.risk.RiskEvaluationCriteriaVersion.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.ListRiskEvaluationCriteriaVersionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.ListRiskEvaluationCriteriaVersionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.ListRiskEvaluationCriteriaVersionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationCriteriaVersionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.ListRiskEvaluationCriteriaVersionsRequest}
 */
proto.risk.ListRiskEvaluationCriteriaVersionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.ListRiskEvaluationCriteriaVersionsRequest;
  return proto.risk.ListRiskEvaluationCriteriaVersionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.ListRiskEvaluationCriteriaVersionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.ListRiskEvaluationCriteriaVersionsRequest}
 */
proto.risk.ListRiskEvaluationCriteriaVersionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.ListRiskEvaluationCriteriaVersionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.ListRiskEvaluationCriteriaVersionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.ListRiskEvaluationCriteriaVersionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationCriteriaVersionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string risk_id = 1;
 * @return {string}
 */
proto.risk.ListRiskEvaluationCriteriaVersionsRequest.prototype.getRiskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.ListRiskEvaluationCriteriaVersionsRequest} returns this
 */
proto.risk.ListRiskEvaluationCriteriaVersionsRequest.prototype.setRiskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.ListRiskEvaluationCriteriaVersionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.ListRiskEvaluationCriteriaVersionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.ListRiskEvaluationCriteriaVersionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.ListRiskEvaluationCriteriaVersionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationCriteriaVersionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionsList: jspb.Message.toObjectList(msg.getVersionsList(),
    proto.risk.RiskEvaluationCriteriaVersion.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.ListRiskEvaluationCriteriaVersionsResponse}
 */
proto.risk.ListRiskEvaluationCriteriaVersionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.ListRiskEvaluationCriteriaVersionsResponse;
  return proto.risk.ListRiskEvaluationCriteriaVersionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.ListRiskEvaluationCriteriaVersionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.ListRiskEvaluationCriteriaVersionsResponse}
 */
proto.risk.ListRiskEvaluationCriteriaVersionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.RiskEvaluationCriteriaVersion;
      reader.readMessage(value,proto.risk.RiskEvaluationCriteriaVersion.deserializeBinaryFromReader);
      msg.addVersions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.ListRiskEvaluationCriteriaVersionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.ListRiskEvaluationCriteriaVersionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.ListRiskEvaluationCriteriaVersionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.ListRiskEvaluationCriteriaVersionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.RiskEvaluationCriteriaVersion.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RiskEvaluationCriteriaVersion versions = 1;
 * @return {!Array<!proto.risk.RiskEvaluationCriteriaVersion>}
 */
proto.risk.ListRiskEvaluationCriteriaVersionsResponse.prototype.getVersionsList = function() {
  return /** @type{!Array<!proto.risk.RiskEvaluationCriteriaVersion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskEvaluationCriteriaVersion, 1));
};


/**
 * @param {!Array<!proto.risk.RiskEvaluationCriteriaVersion>} value
 * @return {!proto.risk.ListRiskEvaluationCriteriaVersionsResponse} returns this
*/
proto.risk.ListRiskEvaluationCriteriaVersionsResponse.prototype.setVersionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.RiskEvaluationCriteriaVersion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskEvaluationCriteriaVersion}
 */
proto.risk.ListRiskEvaluationCriteriaVersionsResponse.prototype.addVersions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.RiskEvaluationCriteriaVersion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.ListRiskEvaluationCriteriaVersionsResponse} returns this
 */
proto.risk.ListRiskEvaluationCriteriaVersionsResponse.prototype.clearVersionsList = function() {
  return this.setVersionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskStatusItem.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskStatusItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskStatusItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskStatusItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    createdAt: jspb.Message.getFieldWithDefault(msg, 1, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 2, 0),
    id: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    color: jspb.Message.getFieldWithDefault(msg, 5, ""),
    order: jspb.Message.getFieldWithDefault(msg, 6, 0),
    borderColor: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskStatusItem}
 */
proto.risk.RiskStatusItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskStatusItem;
  return proto.risk.RiskStatusItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskStatusItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskStatusItem}
 */
proto.risk.RiskStatusItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBorderColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskStatusItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskStatusItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskStatusItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskStatusItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getBorderColor();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional int64 created_at = 1;
 * @return {number}
 */
proto.risk.RiskStatusItem.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.RiskStatusItem} returns this
 */
proto.risk.RiskStatusItem.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 updated_at = 2;
 * @return {number}
 */
proto.risk.RiskStatusItem.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.RiskStatusItem} returns this
 */
proto.risk.RiskStatusItem.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string id = 3;
 * @return {string}
 */
proto.risk.RiskStatusItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskStatusItem} returns this
 */
proto.risk.RiskStatusItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.risk.RiskStatusItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskStatusItem} returns this
 */
proto.risk.RiskStatusItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string color = 5;
 * @return {string}
 */
proto.risk.RiskStatusItem.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskStatusItem} returns this
 */
proto.risk.RiskStatusItem.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 order = 6;
 * @return {number}
 */
proto.risk.RiskStatusItem.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.risk.RiskStatusItem} returns this
 */
proto.risk.RiskStatusItem.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string border_color = 7;
 * @return {string}
 */
proto.risk.RiskStatusItem.prototype.getBorderColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.RiskStatusItem} returns this
 */
proto.risk.RiskStatusItem.prototype.setBorderColor = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.RiskStatuses.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.RiskStatuses.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.RiskStatuses.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.RiskStatuses} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskStatuses.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.risk.RiskStatusItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.RiskStatuses}
 */
proto.risk.RiskStatuses.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.RiskStatuses;
  return proto.risk.RiskStatuses.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.RiskStatuses} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.RiskStatuses}
 */
proto.risk.RiskStatuses.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.RiskStatusItem;
      reader.readMessage(value,proto.risk.RiskStatusItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.RiskStatuses.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.RiskStatuses.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.RiskStatuses} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.RiskStatuses.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.RiskStatusItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RiskStatusItem items = 1;
 * @return {!Array<!proto.risk.RiskStatusItem>}
 */
proto.risk.RiskStatuses.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.risk.RiskStatusItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskStatusItem, 1));
};


/**
 * @param {!Array<!proto.risk.RiskStatusItem>} value
 * @return {!proto.risk.RiskStatuses} returns this
*/
proto.risk.RiskStatuses.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.RiskStatusItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskStatusItem}
 */
proto.risk.RiskStatuses.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.RiskStatusItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.RiskStatuses} returns this
 */
proto.risk.RiskStatuses.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.risk.CreateOrUpdateRiskStatusRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.CreateOrUpdateRiskStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.CreateOrUpdateRiskStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.CreateOrUpdateRiskStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.CreateOrUpdateRiskStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusesList: jspb.Message.toObjectList(msg.getStatusesList(),
    proto.risk.RiskStatusItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.CreateOrUpdateRiskStatusRequest}
 */
proto.risk.CreateOrUpdateRiskStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.CreateOrUpdateRiskStatusRequest;
  return proto.risk.CreateOrUpdateRiskStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.CreateOrUpdateRiskStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.CreateOrUpdateRiskStatusRequest}
 */
proto.risk.CreateOrUpdateRiskStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.risk.RiskStatusItem;
      reader.readMessage(value,proto.risk.RiskStatusItem.deserializeBinaryFromReader);
      msg.addStatuses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.CreateOrUpdateRiskStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.CreateOrUpdateRiskStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.CreateOrUpdateRiskStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.CreateOrUpdateRiskStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatusesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.risk.RiskStatusItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RiskStatusItem statuses = 1;
 * @return {!Array<!proto.risk.RiskStatusItem>}
 */
proto.risk.CreateOrUpdateRiskStatusRequest.prototype.getStatusesList = function() {
  return /** @type{!Array<!proto.risk.RiskStatusItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.risk.RiskStatusItem, 1));
};


/**
 * @param {!Array<!proto.risk.RiskStatusItem>} value
 * @return {!proto.risk.CreateOrUpdateRiskStatusRequest} returns this
*/
proto.risk.CreateOrUpdateRiskStatusRequest.prototype.setStatusesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.risk.RiskStatusItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.risk.RiskStatusItem}
 */
proto.risk.CreateOrUpdateRiskStatusRequest.prototype.addStatuses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.risk.RiskStatusItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.risk.CreateOrUpdateRiskStatusRequest} returns this
 */
proto.risk.CreateOrUpdateRiskStatusRequest.prototype.clearStatusesList = function() {
  return this.setStatusesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.risk.DeleteRiskStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.risk.DeleteRiskStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.risk.DeleteRiskStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DeleteRiskStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskStatusId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.risk.DeleteRiskStatusRequest}
 */
proto.risk.DeleteRiskStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.risk.DeleteRiskStatusRequest;
  return proto.risk.DeleteRiskStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.risk.DeleteRiskStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.risk.DeleteRiskStatusRequest}
 */
proto.risk.DeleteRiskStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskStatusId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.risk.DeleteRiskStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.risk.DeleteRiskStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.risk.DeleteRiskStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.risk.DeleteRiskStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskStatusId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string risk_status_id = 1;
 * @return {string}
 */
proto.risk.DeleteRiskStatusRequest.prototype.getRiskStatusId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.risk.DeleteRiskStatusRequest} returns this
 */
proto.risk.DeleteRiskStatusRequest.prototype.setRiskStatusId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.risk.RISK_TYPE = {
  INHERENT: 0,
  RESIDUAL: 1
};

/**
 * @enum {number}
 */
proto.risk.RISK_STATUS = {
  TODO: 0,
  IN_PROGRESS: 1,
  PENDING: 2,
  COMPLETED: 3
};

/**
 * @enum {number}
 */
proto.risk.RISK_MATH = {
  NOT_SET: 0,
  VERY_LOW: 1,
  LOW: 2,
  MODERATE: 3,
  HIGH: 4,
  VERY_HIGH: 5
};

/**
 * @enum {number}
 */
proto.risk.RISK_TREATMENT = {
  ACCEPT: 0,
  AVOID: 1,
  MITIGATE: 2,
  SHARE: 3,
  TRANSFER: 4
};

/**
 * @enum {number}
 */
proto.risk.RISK_CATEGORY = {
  NO_CATEGORY: 0,
  CUSTOMER: 1,
  VENDOR: 2,
  LEADERSHIP: 3,
  SYSTEMS: 4,
  LAWS: 5,
  IP: 6
};

/**
 * @enum {number}
 */
proto.risk.RISK_LINK_TYPE = {
  LINK: 0,
  UNLINK: 1
};

/**
 * @enum {number}
 */
proto.risk.RISK_IMPORT_FIELD = {
  NO_FIELD: 0,
  THREAT: 1,
  CATEGORY: 2,
  PREDISPOSING_CONDITION: 3,
  ASSET_AT_RISK: 4,
  IMPACT_TO_CUSTOMER: 5,
  LIKELIHOOD: 6,
  ADVERSE_IMPACT: 7,
  RESPONSE: 8,
  TARGET_LIKELIHOOD: 9,
  TARGET_ADVERSE_IMPACT: 10,
  RESIDUAL_RISK: 11,
  STATUS: 12,
  OWNER_EMAIL: 13,
  ASSIGNEE_EMAILS: 14,
  CONTROL_IDS: 15,
  DEPARTMENT_IDS: 16,
  NOTES: 17,
  CREATED_AT: 18
};

goog.object.extend(exports, proto.risk);
